module.exports = __webpack_public_path__ + "img/poster_01.099fba44.png";